import * as React from "react";
const SvgFiRrCursor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cursor_svg__a)">
      <path
        fill="#062147"
        d="M15.008 24a3.01 3.01 0 0 1-2.681-1.636L9.2 15.66l-3.542 3.093A1 1 0 0 1 4 18V2.98A3 3 0 0 1 8.989.734l10.7 10.238a1 1 0 0 1-.6 1.719l-4.468.407 3.065 6.569A3 3 0 0 1 15.008 24M9.543 13.032q.105 0 .207.02a1 1 0 0 1 .7.557l3.675 7.876a1 1 0 1 0 1.767-.94l-3.682-7.891a1 1 0 0 1 .815-1.42l3.7-.336-9.091-8.692a.97.97 0 0 0-1.045-.138A.99.99 0 0 0 6 2.98V15.8l2.885-2.52a1 1 0 0 1 .658-.248"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cursor_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCursor;
